import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";
import Reveal from "@/components/layout/Reveal";
import { SITE } from "@/lib/site";

export default function Hero() {
    return (
        <section
            data-testid="home-hero"
            className="relative min-h-[92vh] flex items-end overflow-hidden bg-navy-700"
        >
            <img
                src="https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/klddihpd_Hero%20header%20-%20Grande.jpeg"
                alt="Chantier de terrassement à Genève"
                className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 hero-vignette" />
            <div className="absolute inset-0 bg-topo-dark opacity-40 mix-blend-overlay" />
            <div className="absolute inset-0 noise-overlay" />

            <div className="relative rcps-container pb-16 md:pb-24 pt-32 md:pt-40 w-full">
                <div className="grid md:grid-cols-12 gap-8 items-end">
                    <div className="md:col-span-8">
                        <Reveal>
                            <div className="flex items-center gap-3">
                                <span className="kicker text-white/80">
                                    <span className="hairline bg-white/60" />
                                    Terrassement à Genève et en Suisse romande
                                </span>
                            </div>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h1 className="mt-6 font-heading font-semibold text-white text-[2rem] sm:text-4xl md:text-5xl lg:text-6xl xl:text-[4.25rem] leading-[1.08] tracking-tight [text-wrap:balance]">
                                Terrassement, démolition et génie civil{" "}
                                <span className="text-white/70 whitespace-nowrap">à Genève.</span>
                            </h1>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 text-white/80 text-base md:text-lg max-w-2xl leading-relaxed">
                                RCPS Terrassement Sàrl accompagne les particuliers, architectes, régies, promoteurs,
                                entreprises générales et collectivités pour leurs travaux de terrassement, démolition,
                                génie civil, voirie, enrobés, aménagements extérieurs et enrochement à Genève et dans
                                toute la Suisse romande.
                            </p>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <div className="mt-8 flex flex-wrap items-center gap-3">
                                <Link
                                    to="/contact"
                                    data-testid="hero-primary-cta-button"
                                    className="inline-flex items-center gap-2 h-12 px-6 rounded-md bg-white text-navy-700 font-semibold hover:bg-concrete-50 transition"
                                >
                                    Demander un devis <ArrowRight className="w-4 h-4" />
                                </Link>
                                <Link
                                    to="/prestations"
                                    data-testid="hero-secondary-cta-button"
                                    className="inline-flex items-center gap-2 h-12 px-6 rounded-md border border-white/30 text-white hover:bg-white/10 font-semibold transition"
                                >
                                    Découvrir nos prestations
                                </Link>
                            </div>
                        </Reveal>
                    </div>

                    <Reveal delay={0.35} className="md:col-span-4">
                        <div className="grid grid-cols-2 gap-3 md:gap-4">
                            <Stat num="4" label="Domaines d’intervention" />
                            <Stat num="GE" label="Ancrage local" />
                            <Stat num="CH" label="Suisse romande" />
                            <Stat num="A–Z" label="De l’étude aux travaux" />
                        </div>
                    </Reveal>
                </div>

                <div className="mt-12 md:mt-16 pt-6 border-t border-white/15 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs uppercase tracking-[0.18em] text-white/60">
                    <span>Particuliers</span>
                    <span className="w-1 h-1 rounded-full bg-white/30" />
                    <span>Architectes</span>
                    <span className="w-1 h-1 rounded-full bg-white/30" />
                    <span>Régies</span>
                    <span className="w-1 h-1 rounded-full bg-white/30" />
                    <span>Promoteurs</span>
                    <span className="w-1 h-1 rounded-full bg-white/30" />
                    <span>Entreprises générales</span>
                    <span className="w-1 h-1 rounded-full bg-white/30" />
                    <span>Collectivités</span>
                </div>
            </div>
        </section>
    );
}

function Stat({ num, label }) {
    return (
        <div className="rounded-md border border-white/15 bg-white/[0.04] backdrop-blur-sm p-4 md:p-5">
            <p className="big-num text-white text-3xl md:text-4xl">{num}</p>
            <p className="mt-1 text-[11px] uppercase tracking-[0.16em] text-white/70">{label}</p>
        </div>
    );
}
